<template>
  <div class="overlay">
    <div class="loader">
      <i class="fa fa-2x fa-spinner fa-spin"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    data: function() {
      return {};
    }
  };
</script>

<style lang="scss">
  @import './style/loader.scss';
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue